import React from 'react';

import { TreeSelectCustomTagProps, Tag } from '@bringg/react-components';
import { useMonitoringTranslations } from '@bringg-frontend/monitoring';

import { NO_TEAM_VALUE } from '../no-team-option/no-team-option';

import styles from './team-custom-tag.module.scss';

const truncateLabel = (label: string, limit = 15) =>
	label.length > limit ? `${label.substring(0, limit).trimEnd()}...` : label;

const TeamCustomTag = ({ value, label, onClose }: TreeSelectCustomTagProps) => {
	const { noTeam } = useMonitoringTranslations();

	return (
		<Tag className={styles.customTag} closable onClose={onClose}>
			{value === NO_TEAM_VALUE ? noTeam : truncateLabel(label as string)}
		</Tag>
	);
};

export default TeamCustomTag;
